import { QueryClient } from '@tanstack/react-query';
import { GetServerSideProps } from 'next';
import { ReactElement } from 'react';
import styled from 'styled-components';

import { NextPageWithLayout } from '../../components/layouts';
import LandingPageLayout from '../../components/layouts/LandingPageLayout';
import TrainingAndPDPage from '../../components/TrainingAndPDPage';
import { detectAndBestEffortSetLanguage } from '../../utils/localisationUtils';
import { dehydrateReactQueryPrefetchedInfiniteQuery } from '../../utils/react-query-utils';

const TITLE = 'Training & Professional Development - Curipod';
const DESCRIPTION =
  'Learn Curipod at your own pace, then bring it to your team. Self-paced course, quick-start video, subject walkthroughs, and print-ready PD kits.';

const TrainingAndPD: NextPageWithLayout = () => {
  return (
    <Container>
      <LandingPageLayout
        hideBlobs={true}
        disableHeadline={true}
        title={TITLE}
        subTitle={DESCRIPTION}
      >
        <TrainingAndPDPage />
      </LandingPageLayout>
    </Container>
  );
};

const Container = styled.div`
  min-height: 100vh;
`;

// This static route intentionally takes precedence over the Webflow proxy in
// pages/c/[...slug].tsx so this page is rendered natively with Curipod's design
// system instead of being pulled from the CMS.
//
// This page is English-only (all linked resources are in English) and has no
// localized `/lang/[locale]/c/...` variant, so we deliberately do NOT call
// getLocaleRedirectIfNeeded here — redirecting a non-default-locale visitor to
// /lang/{locale}/c/... would 404. detectAndBestEffortSetLanguage still sets the
// language for the shared header/footer translations.
export const getServerSideProps: GetServerSideProps = async context => {
  const queryClient = new QueryClient();

  return {
    props: {
      dehydratedState: dehydrateReactQueryPrefetchedInfiniteQuery(queryClient),
      ...(await detectAndBestEffortSetLanguage(context, { routeClass: 'marketing' })),
    },
  };
};

TrainingAndPD.getLayout = function getLayout(page: ReactElement) {
  return <>{page}</>;
};

export default TrainingAndPD;
